import {
  paymentMethod as PaymentMethods,
  paymentType as PaymentTypes,
  paymentMode as PaymentModes,
  policyType as PolicyTypes
} from '@ourbranch/lookups';

export const daysOfMonth = Array.from({ length: 28 }, (_, day) => ({
  id: day + 1,
  value: `${day + 1}`
}));

export const maskingDots = '\u25CF\u25CF\u25CF\u25CF';

// Single source of truth for how each payment method constrains paymentType/paymentMode. Two callers
// share it so the rules can't drift: the payment-method sub-components enforce it on mount (via
// useNormalizePaymentMethod), and the Payment tab seeds its Formik initialValues from it so the form
// doesn't open pre-dirtied — the on-mount pass then finds nothing to change and the "Save changes"
// footer only shows on real edits (#32985).
export const getNormalizedBillingDefaults = ({ paymentMethod, paymentType, paymentMode, policyType }) => {
  // When paymentMethod is unset, mirror billing-details-form's `values.paymentMethod || defaultPaymentMethod`
  // render fallback so the seed matches whichever method component actually mounts.
  const effectiveMethod =
    paymentMethod || (policyType === PolicyTypes.Auto ? PaymentMethods.CreditCard : PaymentMethods.Escrow);

  switch (effectiveMethod) {
    case PaymentMethods.ACH:
      return {
        paymentType: paymentType === PaymentTypes.Escrow ? PaymentTypes.OneTime : paymentType,
        paymentMode: PaymentModes.Automated
      };
    case PaymentMethods.CreditCard:
      return { paymentType, paymentMode: PaymentModes.Automated };
    case PaymentMethods.Escrow:
      return { paymentType: PaymentTypes.Escrow, paymentMode: PaymentModes.Automated };
    case PaymentMethods.Direct:
      return { paymentType, paymentMode: PaymentModes.Direct };
    case PaymentMethods.BillToOther:
      return { paymentType: PaymentTypes.OneTime, paymentMode: PaymentModes.Direct };
    default:
      return { paymentType, paymentMode };
  }
};
